import clamp from "lodash/clamp";
import { InputFocusProps } from "PFComponents/table/interactive/use_cell_input_focus";
import { InputFieldSet } from "PFComponents/text/input_field_set";
import { AvailabilityRule } from "PFCore/types";
import { RefObject } from "react";

import css from "../../../tabular_roles_form.module.scss";

type AvailabilityThresholdCellProps = {
  availability: AvailabilityRule | null;
  onChange: (availability: AvailabilityRule | null) => void;
  disabled?: boolean;
  error?: string;
  inputFocusProps?: InputFocusProps;
  ref?: RefObject<HTMLInputElement>;
};

export const AvailabilityThresholdCell = ({
  availability,
  onChange,
  disabled,
  error,
  inputFocusProps,
  ref
}: AvailabilityThresholdCellProps) => (
  <InputFieldSet
    ref={ref}
    inputClassName={css.singleLineInput}
    inputType="number"
    min={0}
    max={100}
    variant="table"
    value={availability?.availability_threshold}
    disabled={disabled}
    error={error}
    onChange={(value) =>
      onChange({
        ...availability,
        availability_threshold: clamp(Number(value), 0, 100)
      } as AvailabilityRule)
    }
    {...inputFocusProps}
  />
);
